export const EXPERT_STUB = {
  id: -1,
  mainImage: '',
  name: '',
  subtitle: '',
};

export const EXPERTS = [
  {
    id: 91,
    mainImage:
      'https://images.ctfassets.net/63zu1jme7dht/1J152C7HrCIW0P30YRSiq8/acfa1f3e9ab79f42f3fffdb54767893e/91.jpg',
    primary_image:
      'https://images.ctfassets.net/63zu1jme7dht/VyEiyJUH6HO4wnqcgPVsa/a777db597573e1b8dd15615de8be58df/91-300x300-_2x.jpg.jpg',
    secondary_image:
      'https://images.ctfassets.net/63zu1jme7dht/3uYw6dQUItV6IwIozHSwYr/85b050f1f1c5a090a8079635acf9cbb0/91-64x64-_2x.jpg.jpg',
    name: 'Daan Hartevelt',
    subtitle: 'Stamps',
    url: 'https://www.catawiki.com/en/e/91-daan-hartevelt',
    gender: 'Male',
    profile_complete: true,
  },
  {
    id: 425,
    mainImage:
      'https://images.ctfassets.net/63zu1jme7dht/4WqPIABL49kLzHU9clEoIK/f1dbf4f7421868c6d7a4c96b1db4a822/425.jpg',
    primary_image:
      'https://images.ctfassets.net/63zu1jme7dht/6qKMtwhs7aVoUEwH8r8K49/03a89503df00491475fa282cc842f274/425-300x300-_2x.jpg.jpg',
    secondary_image:
      'https://images.ctfassets.net/63zu1jme7dht/4HgnkAkW419gCD3AnhC6JL/1300a19739953ac086a6ad7097428fcb/425-64x64-_2x.jpg.jpg',
    name: 'Nicolas Pereira',
    subtitle: 'Stamps',
    url: 'https://www.catawiki.com/en/e/425-nicolas-pereira',
    gender: 'Male',
    profile_complete: true,
  },
  {
    id: 567,
    mainImage:
      'https://images.ctfassets.net/63zu1jme7dht/70jduymla3M1goylbQRDVd/7845dc3852aa942a93ee5c88c82a31eb/567.jpg',
    primary_image:
      'https://images.ctfassets.net/63zu1jme7dht/25KTVZ2I46d8vk1zYW5zo1/161c131aa6350d190fc675b164c2e981/567-300x300-_2x.jpg.jpg',
    secondary_image:
      'https://images.ctfassets.net/63zu1jme7dht/2Xhf2iE6OYkXQkd4RdomJW/70e078ebf7edd015fe07be8ee53f0093/567-64x64-_2x.jpg.jpg',
    name: 'Manuela Sorani',
    subtitle: 'Stamps',
    url: 'https://www.catawiki.com/en/e/567-manuela-sorani',
    gender: 'Female',
    profile_complete: true,
  },
  {
    id: 695,
    mainImage:
      'https://images.ctfassets.net/63zu1jme7dht/4LIn3OSb30wKls3n0MTkjw/f6bf9656713a767e39ccfe7b47b5560d/695.jpg',
    primary_image:
      'https://images.ctfassets.net/63zu1jme7dht/7LpxAaD4AdHrbSa3KslmmV/44a45936af6b01b727dee1f8bb911183/695-300x300-_2x.jpg.jpg',
    secondary_image:
      'https://images.ctfassets.net/63zu1jme7dht/69BYu3lnznF3FHHdmYIYPX/cd777d96d9928c8f8b401ae18d9f6c2d/695-64x64-_2x.jpg.jpg',
    name: 'Serena Vignati',
    subtitle: 'Stamps',
    url: 'https://www.catawiki.com/en/e/695-serena-vignati',
    gender: 'Female',
    profile_complete: true,
  },
  {
    id: 771,
    mainImage:
      'https://images.ctfassets.net/63zu1jme7dht/677j0ialjhBoxbDMNNg21C/41e44e5d92d4d4000555b32a64016544/771.jpg',
    primary_image:
      'https://images.ctfassets.net/63zu1jme7dht/76Ree2uydRuQ2hS8E1X6a4/6ad9c522bd957853377ebdadcad87f73/771-300x300-_2x.jpg.jpg',
    secondary_image:
      'https://images.ctfassets.net/63zu1jme7dht/qxZZIxDO0b9pL2caApJI1/996f30ec70e71eccf47b3e4db42acb01/771-64x64-_2x.jpg.jpg',
    name: 'Benedikt Reichl',
    subtitle: 'Stamps',
    url: 'https://www.catawiki.com/en/e/771-benedikt-reichl',
    gender: 'Male',
    profile_complete: true,
  },
  {
    id: 927,
    mainImage:
      'https://images.ctfassets.net/63zu1jme7dht/5auZ1SswvStMgE2Hj7F1Ij/c7836e2e5fde0d7dc46f105e9918f838/927.jpg',
    primary_image:
      'https://images.ctfassets.net/63zu1jme7dht/5eFugdMGvH7ec6ZL8lcUlq/89d2f7d6462b9987f4378ce8d212f0b9/927-300x300-_2x.jpg.jpg',
    secondary_image:
      'https://images.ctfassets.net/63zu1jme7dht/3B2qwSUGOvJvMzRC5chrE7/5bd4f0084d85077113b2f1f9df9445d8/927-64x64-_2x.jpg.jpg',
    name: 'Andrea Diano',
    subtitle: 'Stamps',
    url: 'https://www.catawiki.com/en/e/927-andrea-diano',
    gender: 'Male',
    profile_complete: true,
  },
  {
    id: 447,
    mainImage:
      'https://images.ctfassets.net/63zu1jme7dht/HSQfEfKCAIRj3LnK30ohJ/2dc7522cbfa3f2239c36c82df360933d/447.jpg',
    primary_image:
      'https://images.ctfassets.net/63zu1jme7dht/5Fo6k3FzfBrPyJctSTkwr5/9c070e2d8c98b7968502dcb8ccef8bab/447-300x300-_2x.jpg.jpg',
    secondary_image:
      'https://images.ctfassets.net/63zu1jme7dht/53anv8VQbRSIpx3PeQ7ebn/1d81ba32de7e3ddf5b3e45c6cff15a99/447-64x64-_2x.jpg.jpg',
    name: 'Anton Stikkelman',
    subtitle: 'Postcards',
    url: 'https://www.catawiki.com/en/e/447-anton-stikkelman',
    gender: 'Male',
    profile_complete: true,
  },
  {
    id: 167,
    mainImage:
      'https://images.ctfassets.net/63zu1jme7dht/7hetQV8AauUkcV49CMmPWB/0aba5fa6f8ef495e18d6529e8bee26a8/mainImage_167.png',
    primary_image:
      'https://images.ctfassets.net/63zu1jme7dht/6IIELODoTRceq3CkNmgOLY/312150cb4c62dd3ac6413e52efb20d66/primary_image_167.png',
    secondary_image:
      'https://images.ctfassets.net/63zu1jme7dht/4bXBqzqGerFbUHs0iCVE8A/92f04986ec9bcfd7011eb659af1eedd4/secondary_image_167.png',
    name: 'Philipp Rott',
    subtitle: 'Modern Coins',
    url: 'https://www.catawiki.com/en/e/167-philipp-rott',
    gender: 'Male',
    profile_complete: true,
  },
  {
    id: 303,
    mainImage:
      'https://images.ctfassets.net/63zu1jme7dht/252DVkgg7AZwQo9QA6CGE0/09625feac90771fcf41698678dc967d4/303.jpg',
    primary_image:
      'https://images.ctfassets.net/63zu1jme7dht/IMp9frmk5l9nWrm9GhGNE/4c217c7999a57ff64e799ef68ef0259d/303-300x300-_2x.jpg.jpg',
    secondary_image:
      'https://images.ctfassets.net/63zu1jme7dht/2vW7RVjg4mgMaxN94jY5d1/76594ed24876e2b829f3056f2ee0d794/303-64x64-_2x.jpg.jpg',
    name: 'Marcel Spijkerbosch',
    subtitle: 'Modern Coins',
    url: 'https://www.catawiki.com/en/e/303-marcel-spijkerbosch',
    gender: 'Male',
    profile_complete: true,
  },
  {
    id: 399,
    mainImage:
      'https://images.ctfassets.net/63zu1jme7dht/3ycoYmSSWpmrjHBngaoic1/49e3c4894df407282cacec4cbca7d098/399.jpg',
    primary_image:
      'https://images.ctfassets.net/63zu1jme7dht/V0sWQZ5xKqnBR9BgyiIWx/e2f930343f31cf58fcb051144b4e281d/399-300x300-_2x.jpg.jpg',
    secondary_image:
      'https://images.ctfassets.net/63zu1jme7dht/64cx1AgEpHaeiLRyRfd08g/c97a83f659451e1e78a9851ff2ade660/399-64x64-_2x.jpg.jpg',
    name: 'Jacopo Corsi',
    subtitle: 'Modern Coins',
    url: 'https://www.catawiki.com/en/e/399-jacopo-corsi',
    gender: 'Male',
    profile_complete: true,
  },
  {
    id: 605,
    mainImage:
      'https://images.ctfassets.net/63zu1jme7dht/4yEZkqBrLDJxWjhQZaRmLv/d3be7d8b1f32f6097813e3c1dde66f20/605.jpg',
    primary_image:
      'https://images.ctfassets.net/63zu1jme7dht/65N7q7ea48Et3Ie0OZJkvj/dac21b2cfc685c1c2e746a99da6d8e8e/605-300x300-_2x.jpg.jpg',
    secondary_image:
      'https://images.ctfassets.net/63zu1jme7dht/jwDAi2OIpADgyF4Kpsx8J/f7d321b2dfae4fb3c5371c61c508bd1b/605-64x64-_2x.jpg.jpg',
    name: 'Ugo Leca',
    subtitle: 'Modern Coins',
    url: 'https://www.catawiki.com/en/e/605-ugo-leca',
    gender: 'Male',
    profile_complete: true,
  },
  {
    id: 685,
    mainImage:
      'https://images.ctfassets.net/63zu1jme7dht/5MVLUoqESIdCLI86QUvIdd/4d94956ffa32562e337de97028ec28af/685.jpg',
    primary_image:
      'https://images.ctfassets.net/63zu1jme7dht/4V6BRXwXGR7L4BeQdyx3em/3d35acd401fea9372dc9c9d505a437f2/685-300x300-_2x.jpg.jpg',
    secondary_image:
      'https://images.ctfassets.net/63zu1jme7dht/5ZjBSpskLtxvEoFnap6R2O/c9555df8920ba308f535519e684e215d/685-64x64-_2x.jpg.jpg',
    name: 'Danny Neuzerling',
    subtitle: 'Modern Coins',
    url: 'https://www.catawiki.com/en/e/685-danny-neuzerling',
    gender: 'Male',
    profile_complete: true,
  },
  {
    id: 703,
    mainImage:
      'https://images.ctfassets.net/63zu1jme7dht/4kTs223QQDXHrutpOl2zog/a384333d3c867dcf0f25b5e5d1ff04f0/mainImage_703.png',
    primary_image:
      'https://images.ctfassets.net/63zu1jme7dht/7KBWckqWwa9b1s4HtuNTpM/9646c0d84a18646650fa858cac2e8ea4/primary_image_703.png',
    secondary_image:
      'https://images.ctfassets.net/63zu1jme7dht/5ppibyQ8Z0WJOWxFhFtQrI/73da38c7f718e347d57450774787b908/secondary_image_703.png',
    name: 'Helder Silva',
    subtitle: 'Modern Coins',
    url: 'https://www.catawiki.com/en/e/703-helder-silva',
    gender: 'Male',
    profile_complete: true,
  },
  {
    id: 775,
    mainImage:
      'https://images.ctfassets.net/63zu1jme7dht/789tKIq54zbHHHcEPARKxK/6549165e57cb60025ad62fa8c157dd07/775.jpg',
    primary_image:
      'https://images.ctfassets.net/63zu1jme7dht/5ez1B7S0hO2byOZfIWN074/bd4c6fef1b8c85580a25cbebbcfc7871/775-300x300-_2x.jpg.jpg',
    secondary_image:
      'https://images.ctfassets.net/63zu1jme7dht/2siMkOGQbsXGzJVIyBINWM/af0a622b78e0912105c5be6f73cea7d7/775-64x64-_2x.jpg.jpg',
    name: 'Yunheng Deng',
    subtitle: 'Modern Coins',
    url: 'https://www.catawiki.com/en/e/775-yunheng-deng',
    gender: 'Male',
    profile_complete: true,
  },
  {
    id: 1133,
    mainImage:
      'https://images.ctfassets.net/63zu1jme7dht/5S7B8XtaIsVqM7L3XxseJu/b3d7c40f1e7f130a7722a447afed7900/mainImage_1133.png',
    primary_image:
      'https://images.ctfassets.net/63zu1jme7dht/7yNfEesb6oRBveJypnPwYQ/055dbfe61ddac0391e2f3294494a8163/primary_image_1133.png',
    secondary_image:
      'https://images.ctfassets.net/63zu1jme7dht/2TCabMCx0tImsambtREKrN/5e14c2312f5355ce8e6a53fe099cbaa0/secondary_image_1133.png',
    name: 'Soufian El Guesaoui',
    subtitle: 'Modern Coins',
    url: 'https://www.catawiki.com/en/e/1133-soufian-el-guesaoui',
    gender: 'Male',
    profile_complete: true,
  },
  {
    id: 273,
    mainImage:
      'https://images.ctfassets.net/63zu1jme7dht/1jB4DO3HdTahDCIg7uv4m2/4eb452fce65e8da1802f8d2471ca4e39/273.jpg',
    primary_image:
      'https://images.ctfassets.net/63zu1jme7dht/5I73qvjw8PW1frAFrrEl4i/56855018758006ac2ea5faacc245dc10/273-300x300-_2x.jpg.jpg',
    secondary_image:
      'https://images.ctfassets.net/63zu1jme7dht/410bUM5ZAMKd5hkIJiswu7/5da0fe135b409badb351cafcfb7db9aa/273-64x64-_2x.jpg.jpg',
    name: 'Willem Knapen',
    subtitle: 'Ancient Coins',
    url: 'https://www.catawiki.com/en/e/273-willem-knapen',
    gender: 'Male',
    profile_complete: true,
  },
  {
    id: 1107,
    mainImage:
      'https://images.ctfassets.net/63zu1jme7dht/hDdHlcTW7VglPfEPbIN6M/65f888a7c4e4365b9448b16783764a9e/mainImage_1107.png',
    primary_image:
      'https://images.ctfassets.net/63zu1jme7dht/7LGRPiDvNgf2Hc6siTE1Qe/d4da7b54221e54da15899d2b5bc7a708/primary_image_1107.png',
    secondary_image:
      'https://images.ctfassets.net/63zu1jme7dht/4JfH7KOSTEH4vSdiEIeoXQ/152ee893fd1d85beb8207b54a4e4f5d9/secondary_image_1107.png',
    name: 'Alessandro Fiamingo',
    subtitle: 'Modern Coins',
    url: 'https://www.catawiki.com/en/e/1107-alessandro-fiamingo',
    gender: 'Male',
    profile_complete: true,
  },
];
